import {Component, forwardRef, Injector} from "@angular/core";
import {AbstractInvertedBooleanEditControlComponent} from "../../edit-controls/abstract-inverted-boolean-edit-control.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => EntityDiscontinuedEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-entity-discontinued-edit-control",
    templateUrl: "entity-discontinued-edit-control.component.html",
    providers: [CUSTOM_VALUE_ACCESSOR]
})
export class EntityDiscontinuedEditControlComponent extends AbstractInvertedBooleanEditControlComponent {

    constructor(injector: Injector) {
        super(injector);
    }
}
